import React from 'react';
import { defineMessages } from 'react-intl';
import { QuotesIcon } from '../../common/icons/quotesIcon';
import { FlightsIcon } from '../../common/icons/flightsIcon';
import { UploadIcon } from '../../common/icons/uploadIcon';
import { DownloadIcon } from '../../common/icons/downloadIcon';
import { Features, FeaturesWideLayout } from 'acscp/components/auth/features/features';

const messages = defineMessages({
    quotesTitle: {
        id: 'web.components.pages.jetPortalFeatures.quotesTitle',
        defaultMessage: 'VIEW AND ACCEPT QUOTES ONLINE'
    },
    quotesText: {
        id: 'web.components.pages.jetPortalFeatures.quotesText',
        defaultMessage:
            'You are able to view detailed quotes including prices, ' +
            'flight times and a range of further details of available aircraft, before accepting your preferred quotation.'
    },
    itinerariesTitle: {
        id: 'web.components.pages.jetPortalFeatures.itinerariesTitle',
        defaultMessage: 'FLIGHT DETAILS & ITINERARY'
    },
    itinerariesText: {
        id: 'web.components.pages.jetPortalFeatures.itinerariesText',
        defaultMessage:
            'Gain quick access to any flight details whenever and wherever they are needed. ' +
            'Whether it is for directions on the way to the airport, or to check departure times, a quick tap can provide all.'
    },
    sharingTitle: {
        id: 'web.components.pages.jetPortalFeatures.sharingTitle',
        defaultMessage: 'SHARE FUNCTIONALITY'
    },
    sharingText: {
        id: 'web.components.pages.jetPortalFeatures.sharingText',
        defaultMessage:
            'JetPortal allows you to share quotes and itineraries with whomever you need at a click of a button. ' +
            'It also allows decision makers to accept their preferred quotes directly.'
    },
    offlineInformationTitle: {
        id: 'web.components.pages.jetPortalFeatures.offlineInformationTitle',
        defaultMessage: 'ACCESS YOUR FLIGHT INFORMATION OFFLINE'
    },
    offlineInformationText: {
        id: 'web.components.pages.jetPortalFeatures.offlineInformationText',
        defaultMessage: 'Downloading the app version of JetPortal will allow you to view your flight information offline when necessary.'
    }
});

export const JetPortalFeatures: React.FC<{fourColumnLayout: boolean}> = props => (
    <Features
        layout={props.fourColumnLayout ? FeaturesWideLayout.FourColumns : FeaturesWideLayout.TwoColumns}
        feature1={{
            icon: <QuotesIcon/>,
            title: messages.quotesTitle,
            text: messages.quotesText
        }}
        feature2={{
            icon: <FlightsIcon/>,
            title: messages.itinerariesTitle,
            text: messages.itinerariesText
        }}
        feature3={{
            icon: <UploadIcon/>,
            title: messages.sharingTitle,
            text: messages.sharingText
        }}
        feature4={{
            icon: <DownloadIcon/>,
            title: messages.offlineInformationTitle,
            text: messages.offlineInformationText
        }}
    />
);
